import { $eq as __eq, createQueryOperator } from "../../_predicates";
const $eq = createQueryOperator(__eq);
export {
  $eq
};
